import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { MultiSelectionInput } from "colbi_web_ui/lib/components/inputs";
import defaultStyles from "./TranslationTableAssociation.module.sass";

const TranslationTableAssociation = ({
  selectedTranslationTableAssociation,
  translationsTable,
  handleChange,
  containerTitle,
  projectId,
}) => {
  const { i18n } = useGlobalValue();
  const valuesSelected =
    selectedTranslationTableAssociation && selectedTranslationTableAssociation.length
      ? selectedTranslationTableAssociation.map((item) => item.translationId)
      : [];

  return (
    <div className={defaultStyles["package-container"]}>
      <h5 className={defaultStyles["input-label"]}>{i18n`${containerTitle}`}</h5>
      {translationsTable && translationsTable.length ?
        <MultiSelectionInput
          value={valuesSelected}
          options={translationsTable || []}
          className={defaultStyles["dropdown"]}
          placeholder={i18n`select translation table`}
          filter
          onChange={(e) => {
            const associationUpdated = e.target.value.map((itemId) => {
              const _associationUpdated = { translationId: itemId, projectId };

              return _associationUpdated;
            });

            handleChange(e, "translationTableAssociation", associationUpdated);
          }}
        /> :
        <small>{i18n`No translation table available`}</small>
      }
    </div>
  );
};

export default TranslationTableAssociation;
